import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked",
  "use": "checked-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 11\" id=\"checked\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 11L0 6l1.4-1.4L5 8.2 12.6.6 14 2l-9 9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol